var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3734 9.00158L17.2484 2.87658C17.0817 2.71407 16.8578 2.6237 16.625 2.62501H6.125C5.66087 2.62501 5.21575 2.80939 4.88756 3.13758C4.55937 3.46577 4.375 3.91089 4.375 4.37501V23.625C4.375 24.0891 4.55937 24.5343 4.88756 24.8624C5.21575 25.1906 5.66087 25.375 6.125 25.375H21.875C22.3391 25.375 22.7842 25.1906 23.1124 24.8624C23.4406 24.5343 23.625 24.0891 23.625 23.625V9.62501C23.6263 9.39222 23.5359 9.16827 23.3734 9.00158ZM17.5 19.25H10.5C10.2679 19.25 10.0454 19.1578 9.88128 18.9937C9.71719 18.8296 9.625 18.6071 9.625 18.375C9.625 18.1429 9.71719 17.9204 9.88128 17.7563C10.0454 17.5922 10.2679 17.5 10.5 17.5H17.5C17.7321 17.5 17.9546 17.5922 18.1187 17.7563C18.2828 17.9204 18.375 18.1429 18.375 18.375C18.375 18.6071 18.2828 18.8296 18.1187 18.9937C17.9546 19.1578 17.7321 19.25 17.5 19.25ZM17.5 15.75H10.5C10.2679 15.75 10.0454 15.6578 9.88128 15.4937C9.71719 15.3296 9.625 15.1071 9.625 14.875C9.625 14.643 9.71719 14.4204 9.88128 14.2563C10.0454 14.0922 10.2679 14 10.5 14H17.5C17.7321 14 17.9546 14.0922 18.1187 14.2563C18.2828 14.4204 18.375 14.643 18.375 14.875C18.375 15.1071 18.2828 15.3296 18.1187 15.4937C17.9546 15.6578 17.7321 15.75 17.5 15.75ZM16.625 9.62501V4.81251L21.4375 9.62501H16.625Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceicon);
export default __webpack_public_path__ + "static/media/invoice icon.689504e53a1474d33109082549d0ee6f.svg";
export { ForwardRef as ReactComponent };